import NetUtils from "../../utils/NetUtils";

export default {
    get: async params => {
        const res = await NetUtils.doGet('/asset/GetDashboard', params)
        return res;
    }
}